import SolutionGroups from './SolutionGroups.gql';

export default SolutionGroups;
